import { RawShaderMaterial } from 'three';

import { lisa } from '../../Lisa.js';
import { DEVICE, EVENTS } from '../../constants.js';

import fs from './fragment.fs?hotShader';
import vs from './vertex.vs?hotShader';
import { viewportUniforms } from '../../utils/uniforms.js';

class MouseComputationMaterial extends RawShaderMaterial {
	/**
	 *
	 * @param {import("three").ShaderMaterialParameters} options
	 */
	constructor(options = {}) {
		super(options);
		this.uniforms.uMobile = viewportUniforms.uMobile;

		lisa.state.on(EVENTS.DETACH, this.#onDetach);

		vs.use(this);
		fs.use(this);
	}

	#onDetach() {

		lisa.state.off(EVENTS.DETACH, this.#onDetach);
	}
}

export default MouseComputationMaterial;
